import { html } from "lit";
import { translate } from "../../../locales";
import { shellApi } from "../../api";
import { ImportDataManagerModal } from "./component";

export const template = (props: ImportDataManagerModal) => {
  return html`
    <div class="container">
      <div class="content">
        <primaria-region name="${shellApi.regionManager.regions.shell.importDataActivityHistory}"></primaria-region>
        <primaria-region name="${shellApi.regionManager.regions.shell.importData}"></primaria-region>
      </div>
      <div class="footer">
        <dss-button
          label="${translate("importDataManager.actions.cancel")}"
          @click="${() => {
            props.cancel();
          }}"
          size="md"
          variant="secondary"
        ></dss-button>
        <dss-button
          label="${translate("importDataManager.actions.import")}"
          @click="${() => {
            props._accept();
          }}"
          size="md"
          variant="primary"
        ></dss-button>
      </div>
    </div>
  `;
};
